export type FacilityPermissions = {
  club?: {
    id?: string;
    supportsPublic?: boolean;
    supportsPrivate?: boolean;
  };
  id?: string;
  publicBookingPermissionSet?: {
    isFacilityVisible?: boolean;
    isFacilityBookable?: boolean;
    areOtherBookingsVisible?: boolean;
    areOtherBookingsBookable?: boolean;
    canBookOnBusySlot?: boolean;
  };
  privateBookingPermissionSet?: {
    isFacilityVisible?: boolean;
    isFacilityBookable?: boolean;
    areOtherBookingsVisible?: boolean;
    areOtherBookingsBookable?: boolean;
    canBookOnBusySlot?: boolean;
  };
};

export const getApplicablePermissionSet = (facility: FacilityPermissions) => {
  const { club, publicBookingPermissionSet, privateBookingPermissionSet } =
    facility;
  const { supportsPublic, supportsPrivate } = club || {};

  if (supportsPublic && publicBookingPermissionSet) {
    return publicBookingPermissionSet;
  }

  if (supportsPrivate && privateBookingPermissionSet) {
    return privateBookingPermissionSet;
  }

  return {};
};

export const getPermissionSetVisible = (facility: FacilityPermissions) => {
  if (!facility) return false;
  const permissionSet = getApplicablePermissionSet(facility);
  return (
    permissionSet?.isFacilityVisible &&
    permissionSet?.areOtherBookingsVisible &&
    permissionSet?.isFacilityBookable
  );
};

export const getPermissionSetViewOnly = (facility: FacilityPermissions) => {
  if (!facility) return false;
  const permissionSet = getApplicablePermissionSet(facility);
  return (
    permissionSet?.isFacilityVisible && permissionSet?.areOtherBookingsVisible
  );
};

export const getPermissionSetJoinable = (facility: FacilityPermissions) => {
  if (!facility) return false;
  const permissionSet = getApplicablePermissionSet(facility);
  return (
    permissionSet?.isFacilityVisible &&
    permissionSet?.areOtherBookingsVisible &&
    permissionSet?.isFacilityBookable &&
    permissionSet?.areOtherBookingsBookable
  );
};

export const getPermissionSetHidden = (facility: FacilityPermissions) => {
  if (!facility) return false;
  const permissionSet = getApplicablePermissionSet(facility);
  return (
    !permissionSet?.isFacilityVisible && !permissionSet?.isFacilityBookable
  );
};

export const getPermissionSetAvailabilityOnly = (
  facility: FacilityPermissions
) => {
  if (!facility) return false;
  const permissionSet = getApplicablePermissionSet(facility);
  return !permissionSet?.isFacilityVisible;
};
